import { gsap } from 'gsap/all';
import { strToDom } from 'minsky-kit/js/utils/dom';

export function runFrontAnimation () {
    if (document.querySelector('article.node--1.node--content-page')) {
        const $title = document.querySelector('.node__title');
        const $intro = document.querySelector('.node__intro');
        const $visual = document.querySelector('.node__visual');

        let delay = 0;

        if ($title) {
            delay += 0.5;

            // process title contents
            const words = Array.from($title.querySelectorAll('.node__special-word'));
            const toAnimate = words.concat([strToDom('<span></span>'), strToDom('<span></span>'), $title]); // 2 empty elements to delay the full title a little more

            gsap.fromTo(toAnimate, {
                color: 'rgba(0,0,0,0)',
            },
            {
                color:    'rgba(0,0,0,1)',
                duration: 1,
                delay,
                ease:     'easeOut',
                stagger:  {
                    amount: 0.75,
                },
            });

            delay += 0.75 * toAnimate.length + 1.5;
        }

        if ($intro) {
            gsap.fromTo($intro, {
                y:       50,
                opacity: 0,
            }, {
                y:        0,
                opacity:  1,
                ease:     'sine-in',
                duration: 0.5,
                delay:    0.25 + (delay * 0.25),
            });

            delay++;
        }

        if ($visual) {
            gsap.fromTo($visual, {
                y:       50,
                opacity: 0,
            }, {
                y:        0,
                opacity:  1,
                ease:     'sine-in',
                duration: 0.5,
                delay:    0.25 + (delay * 0.25),
            });
        }

        return true;
    }
    return false;
}
